import script from "./Lightbox.vue?vue&type=script&setup=true&lang=ts"
export * from "./Lightbox.vue?vue&type=script&setup=true&lang=ts"

import "./Lightbox.vue?vue&type=style&index=0&id=08330390&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08330390"]])

export default __exports__